<template>
  <div>
    <autocomplete
      ref="autocomplete"
      :placeholder="trans.placeholder"
      :results-display="formattedDisplay"
      :source="distributionGroupsEndpoint"
      input-class="form-control"
      name="mapscity"
      results-property="data"
      @selected="addDistributionGroup">
    </autocomplete>
  </div>
</template>

<script>
import config from '@/config'
import Autocomplete from 'vuejs-auto-complete'
import {mapState} from 'vuex'

export default {
  methods: {
    distributionGroupsEndpoint (input) {
      return config.SERVER_DOMAIN + '/api/maps/autocomplete?filterByName=' + input + '&apiKey=' + config.API_KEY
    },
    addDistributionGroup (group) {
      // this.group = group
      // console.log('SELECTED: ')
      // console.log(group)
      // access the autocomplete component methods from the parent
      this.$emit('set-position', { lat: group.selectedObject.lat, lng: group.selectedObject.lon })
      this.$refs.autocomplete.clear()
    },
    formattedDisplay (result) {
      // console.log(result)
      // return result.name + ' [' + result.class + ']'
      return result.name
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.mapAutoComplete,
    }),
  },
  components: {
    Autocomplete,
  },
}
</script>

<style scoped>
</style>
